import React from 'react';
import { ROOT } from '../../../propTypes';
import { getLayerProps } from '../../../lib';
import SVGLayer from '../SVGLayer';

const SVGRoot = ({ layers = [], transform, ...svgAttributes }) => {
    const svgMappedAttributes = getLayerProps(svgAttributes);

    const renderRoot = () => (
        <svg {...svgMappedAttributes}>
            {layers.map((layer) => (
                <SVGLayer key={layer.layerId} {...getLayerProps(layer)} />
            ))}
        </svg>
    );

    const rootTransform = transform || svgMappedAttributes.transform;

    return <g transform={rootTransform}>{renderRoot()}</g>;
};

SVGRoot.propTypes = {
    ...ROOT,
};

export default SVGRoot;
